export default "/images/0ff5c257087cd90be9ffd861923b6e8f.jpg";